<template>
<!-- the Material top bar: the name and the way to the services and the contact form -->
<header id="header" class="app-top-bar">
    <router-link to="/" class="top-bar-brand">
        <inline-svg class="brand-logo" :src="svg('symbol.svg')" width="32" height="28" />
        <span>UO Konsult</span>
    </router-link>
    <nav class="top-bar-nav">
        <router-link :to="{ path: '/', hash: '#tjanster' }" class="top-bar-link" :class="{ active: isSelected('/', '#tjanster') }" aria-label="Våra tjänster">
            <inline-svg :src="svg('gift.svg')" width="20" height="20" />
            <span class="top-bar-label">Våra tjänster</span>
        </router-link>
        <router-link to="/kontakt" class="top-bar-link" :class="{ active: isSelected('/kontakt') }" aria-label="Kontakt">
            <inline-svg :src="svg('phone.svg')" width="20" height="20" />
            <span class="top-bar-label">Kontakt</span>
        </router-link>
    </nav>
</header>
</template>

<script>
export default {
    name: 'Menu',
    methods: {
        isSelected(path, hash) {
            return this.$route.path == path && (!hash || this.$route.hash == hash);
        },
        svg(path) {
            return this.$images.svg(path)
        }
    }
}
</script>

<style scoped lang="scss">
.app-top-bar {
    position: sticky;
    top: 0;
    z-index: 1030;
    height: calc(var(--md-top-bar-height) + env(safe-area-inset-top, 0px));
    padding: env(safe-area-inset-top, 0px) 12px 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 8px;
    background: var(--md-primary);
    color: #fff;
}

.top-bar-brand {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 22px;
    font-weight: 800;
    color: #fff;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
        color: #fff;
    }
}

// the logo is drawn in black: white on the bar
.brand-logo ::v-deep path {
    fill: #fff !important;
}

.top-bar-nav {
    display: flex;
    gap: 4px;
}

.top-bar-link {
    height: 40px;
    padding: 0 14px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #fff;
    font-size: 15px;
    font-weight: 800;
    text-decoration: none;

    &:hover,
    &:focus-visible {
        background: rgba(255, 255, 255, 0.14);
        color: #fff;
    }

    &.active {
        background: var(--md-primary-container);
        color: var(--md-primary-dark);
    }
}

// a phone: the icons only
@media (max-width: 575px) {
    .top-bar-link {
        width: 44px;
        padding: 0;
        justify-content: center;
    }

    .top-bar-label {
        display: none;
    }
}
</style>
